import React from "react";
import { MessengerService, PluginWrapper } from "@vlogr/plugin-sdk";
import { Main } from "./components";
import DragIcon from "./assets/images/drag-icon.png";

interface IItem {
  type: string;
  file: string;
  size: string;
}

function App() {
  const messengerService = new MessengerService(window as unknown as Window);

  const create = (data: IItem[]) => {
    messengerService.create(data, (data: any): void => {
      // do nothing
    });
  };

  const dragStart = (event: React.DragEvent<HTMLDivElement>, data: any) => {
    if (data) {
      const elements = [];
      elements.push({
        type: "video",
        file: data.file || data.mp4,
        size: data.fileSize,
      });
      messengerService.dragStart(elements, (data: any): void => {
        // do nothing
      });
    }
  };

  const dragEnd = (event: React.DragEvent<HTMLDivElement>, payload: any) => {
    messengerService.dragEnd(payload, (data: any): void => {
      // do nothing
    });
  };

  const componentCallback = (data: any): void => {
    const elements = [];
    elements.push({
      type: "video",
      file: data.file || data.mp4,
      size: data.fileSize,
    });
    create(elements);
  };

  return (
    <PluginWrapper messenger={messengerService}>
      <Main
        getGiphyStickersData={componentCallback}
        onDragStart={dragStart}
        onDragEnd={dragEnd}
      />
    </PluginWrapper>
  );
}

export default App;
